import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=325e65ca&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&id=325e65ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325e65ca",
  null
  
)

export default component.exports